module.exports = __webpack_public_path__ + "static/hot.90fd718e.png";